var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66734 18.8333H13.334C16.684 18.8333 17.284 17.4917 17.459 15.8583L18.084 9.19167C18.309 7.15833 17.7257 5.5 14.1673 5.5H5.834C2.27567 5.5 1.69234 7.15833 1.91734 9.19167L2.54234 15.8583C2.71734 17.4917 3.31734 18.8333 6.66734 18.8333Z",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 5.50002V4.83335C6.66602 3.35835 6.66602 2.16669 9.33268 2.16669H10.666C13.3327 2.16669 13.3327 3.35835 13.3327 4.83335V5.50002",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 11.3333V12.1667C11.6673 12.175 11.6673 12.175 11.6673 12.1833C11.6673 13.0917 11.659 13.8333 10.0007 13.8333C8.35065 13.8333 8.33398 13.1 8.33398 12.1917V11.3333C8.33398 10.5 8.33398 10.5 9.16732 10.5H10.834C11.6673 10.5 11.6673 10.5 11.6673 11.3333Z",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.041 9.66669C16.116 11.0667 13.916 11.9 11.666 12.1834",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18359 9.89166C4.05859 11.175 6.17526 11.95 8.33359 12.1917",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.a657eab725f8708520e44fdd4a051352.svg";
export { ForwardRef as ReactComponent };